import ExecutionStateParser from './ExecutionStateParser';
import { ActionState, ExecutionStatus } from './ExecutionConstants';

class ExecutionTestActionStateParser {
    private execution: any;
    private executionStatus: ExecutionStatus;

    constructor(execution: any) {
        this.execution = execution;
        this.executionStatus = new ExecutionStateParser().parseState(execution).status;
    }

    getActionState(actionName: string) {
        if (this.executionStatus === ExecutionStatus.AwaitingApprovals ||
            this.executionStatus === ExecutionStatus.Scheduled ||
            this.executionStatus === ExecutionStatus.Ready) {
            return ActionState.NotStarted;
        }

        const action = this.execution.TestSets.find(item => item.ActionName === actionName);

        if (!action) {
            if (this.executionStatus === ExecutionStatus.Passed) {
                return ActionState.Unknown;
            } else {
                return ActionState.NotStarted;
            }
        }

        if (action.Errors && action.Errors.length) {
            return ActionState.Failed;
        }

        if (action.Running) {
            return ActionState.InProgress;
        }

        return action.TotalPassed === action.Tests.length ? ActionState.Passed : ActionState.Failed;
    }
}

export default ExecutionTestActionStateParser;